export const CONFIGURATION = {

  'basefileformsURL': 'http://siprasoftware.com:8888/api/',
  

  // Prod Domain API
  'baseLoginURL': 'https://api.uat.acaanalytics.revolutiones.org/usermgmt-0.0.1-SNAPSHOT/user/',
  'baseloginhicURL': 'https://api.uat.acaanalytics.revolutiones.org/ACAUserManagement-0.0.1/auth/login',
  'baseServiceUrl': 'https://api.uat.acaanalytics.revolutiones.org/ReportingPortalWebAPI/rest/',
  'baseDataBoardingUrl': 'https://api.uat.acaanalytics.revolutiones.org/DataOnBoardingWebAPI/rest/',
  'basefile1094CURL': 'https://api.uat.acaanalytics.revolutiones.org/hicportalwebapi/',
  'baseIrsstatusURL': 'https://api.uat.acaanalytics.revolutiones.org/submission/',
  'baseGenerateIrsURL': 'https://api.uat.acaanalytics.revolutiones.org/edwrirsairui/irsairui',
  'baseAuthURL': 'https://api.uat.acaanalytics.revolutiones.org/ACAUserManagement-0.0.1/auth',
  'baseFileUploadURL': 'https://api.uat.acaanalytics.revolutiones.org/file-upload-0.0.1-SNAPSHOT/',
  'baseURL': 'https://api.uat.acaanalytics.revolutiones.org/ACAUserManagement-0.0.1/',



  'reportingroute': 'reporting',
  'dashboard': 'dashboard',
  'fileupload': 'fileupload',
  'nftreport': 'nhftreport',
  'empnhreport': 'empnhreport',
  'enftreport': 'enftreport',
  'ogreport': 'ogreport',
  'pdareport': 'pdareport',
  'ercreport': 'ercreport',
  'empsummary': 'empsummary',
  'empeligilbility': 'empeligilbility',
  'empstabilityperiod': 'empstabilityperiod',
  'empdemographics': 'empdemographics',
  'empbreakinservice': 'empbreakinservice',
  'federalpayday': 'federalpayday',
  'statepayday': 'statepayday',
  'addcustomer': 'addcustomer',
  'listcustomer': 'listcustomer',
  'onboardingcustomerinformation': 'onboardingcustomerinformation',
  'clientpayroll': 'clientpayroll',
  'onboardingpersonalinformation': 'onboardingpersonalinformation',
  'uploaddata': 'uploaddata',
  'aledataupload': 'aledataupload',
  'payrolldataupload': 'payrolldataupload',
  'insurancedataupload': 'insurancedataupload',
  'onezeroninefourdataupload': 'onezeroninefourdataupload',
  'onezeroninefivedataupload': 'onezeroninefivedataupload',
  'controlgroup': 'controlgroup',
  'ale': 'ale',
  'aledetails': 'aledetails',
  'legalentities': 'legalentities',
  'insuranceinfo': 'insuranceinfo',
  'acadata': 'acadata',
  'o1095c': 'o1095c',
  'filemanager': 'filemanager',
  'usermanagement': 'usermanagement',
  'irsdatasubmittedstatus': 'irsdatasubmittedstatus',
  'readytosubmitirs': 'readytosubmitirs',
  'file1095': 'file1095',
  'file1094': 'file1094',
  'generateirs': 'generateirs',
  'shownames': 'shownames',
  'payhistory': 'payhistory',
  'Sick': 'Sick',
  'termination': 'termination',
  'benefitsenrollmentstatus': 'benefitsenrollmentstatus',
  'costanalysisvendor': 'costanalysisvendor',
  'costanalysisshow': 'costanalysisshow',
  'costanalysisaccontnumber': 'costanalysisaccontnumber',
  'costanalysisirs1099': 'costanalysisirs1099',
  'costanalysispayroll': 'costanalysispayroll',
  'costanalysisdocnumber': 'costanalysisdocnumber',
  'invoicedetails': 'invoicedetails',
  'orientationperiod': 'orientationperiod',
  'employeedetails': 'employeedetails',
  'irsaudireport': 'irsaudireport',
  'epcares': 'epcares',
  'auditreport': 'auditreport',
  'acaemploymentstatushistoryreport': 'acaemploymentstatushistoryreport',
  'monthlypaidemployees': 'monthlypaidemployees',
  'report401k': 'report401k',
  'report401kpayments': 'report401kpayments',
  'verificationemployeedata': 'verificationemployeedata',
  'datasheettracker': 'datasheettracker',
  'annualaverage': 'annualaverage',
  'calsaver':'calsaver',
  'calsaversreport':'calsaversreport',
  'newclients':'newclients',
  'sharpnewhire':'sharpnewhire',
  'currentlyemployed':'currentlyemployed',
  "dynamicreport": "dynamicreport",
  "granularlevel": "granularlevel",
  "dei": "dei",
  "detailpayrolledit": "detailpayrolledit",
  "bmpfulltimereport": "bmpfulltimereport",
  "employeeearningsummaryreport": "employeeearningsummaryreport",
  "customaggregatefringe" : "customaggregatefringe",
}



// WEBPACK FOOTER //
// ./src/app/app.config.ts